import API from '../../sunwiseAPI';
const ENTITY = 'edit-reporter';

export const editReport = (id) => API.put(`/api/v1/${ENTITY}/${id}/sunpay`);
